export const createPopupLoadKey = ({
  draftId,
  stateKey,
  openedAt,
  forceRefresh
} = {}) =>
  JSON.stringify([
    draftId == null ? '' : String(draftId),
    stateKey == null ? '' : String(stateKey),
    openedAt == null ? '' : String(openedAt),
    Boolean(forceRefresh)
  ])

export const normalizeRowOrder = (savedOrder, actualKeys) => {
  const actual = Array.isArray(actualKeys) ? actualKeys.map(String) : []
  const actualSet = new Set(actual)
  const normalized = []
  const seen = new Set()

  const appendIfPresent = (key) => {
    const normalizedKey = String(key)
    if (!actualSet.has(normalizedKey) || seen.has(normalizedKey)) return
    seen.add(normalizedKey)
    normalized.push(normalizedKey)
  }

  ;(Array.isArray(savedOrder) ? savedOrder : []).forEach(appendIfPresent)
  actual.forEach(appendIfPresent)

  return normalized
}

export const areRowOrdersEqual = (left, right) =>
  Array.isArray(left) &&
  Array.isArray(right) &&
  left.length === right.length &&
  left.every((key, index) => String(key) === String(right[index]))
